import {
  Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, ElementRef, SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PriceSheetDetailsService } from '../../../services/price-sheet-details/price-sheet-details.service';
import { PriceSheetDetail } from '../../../services/price-sheet-details/price-sheet-details.model';
import { debounce } from 'lodash';
import { Pagination, mockedData, getPaginationHeader } from 'src/app/utils/getPaginationHeader';
import { removeUnSelectedIds } from 'src/app/utils/RemoveUnSelectedIds';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { MySnackBarService } from '../../../shared/snackbar/my-snackbar.service';
import { PriceSheetDetailSingleComponent } from '../price-sheet-detail-single/price-sheet-detail-single.component';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent, ExcelModule, GridComponent, ExcelComponent, ColumnBase } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { ColumnSettings } from "../../../../app/utils/column-settings.interface";
import { StorageService } from '../../../../app/utils/StorageHelper';
import * as XLSX from 'xlsx';
import { ImportsService } from '../../../services/imports/imports.service'
import { emptyLookup, Lookup } from 'src/app/services/lookups/lookups.model';
import { LookupsService } from '../../../services/lookups/lookups.service';
import { NotificationHelper } from '../../../utils/NotificationHelper';
import { ExportConfirmationComponent } from 'src/app/shared/export-confirmation/export-confirmation.component';
import { DeleteConfirmationComponent } from '../../../shared/delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-price-sheet-detail-list',
  templateUrl: './price-sheet-detail-list.component.html',
  styleUrls: ['./price-sheet-detail-list.component.scss'],
})
export class PriceSheetDetailListComponent implements AfterViewInit, OnInit {
  @ViewChild('grid') myGrid: GridComponent;
  @ViewChild('hiddenfileinput') fileUploader: ElementRef;

  constructor(
    private priceSheetDetailsService: PriceSheetDetailsService,
    private router: Router,
    private modalService: NgbModal,
    private snack: MySnackBarService,
    private importsService: ImportsService,
    private lookupService: LookupsService,
    private notificationHelper: NotificationHelper
  ) {
    this.onFilterChange = debounce(this.onFilterChange, 300, { leading: true });
    this.allData = this.allData.bind(this);
  }
  @Input() loading: boolean = true;
  @Input() priceSheetID: number;
  @Input() priceSheetDetails: PriceSheetDetail[] = [];
  @Input() query = { PageSize: 25, SortTerm: 'name', PageNumber: 1, SearchTerm: '' };
  @Input() pagination: Pagination = mockedData;
  @Output() filterChange = new EventEmitter();
  @Output() onSelectSingle = new EventEmitter();
  @Input() mode: 'view' | 'lookup' = 'view';
  limits = [25, 50, 75, 100, 250];
  selectedIds: { [key: number]: boolean } = {};
  idForRemove: number | null = null;
  public mySelection: string[] = [];
  public gridView: GridDataResult;
  public pageSize = 25;
  public skip = 0;
  public filter: CompositeFilterDescriptor;
  private data: PriceSheetDetail[];
  public exportAll: boolean;
  public optDescColumns: boolean;
  public optRowID: boolean;
  public globalRecordCount: number = 1;
  public clickedRowItem;
  public gridClassName: string = "PriceSheetDetailSubgridClass";
  public filterable: boolean;
  public priceSheetDetailQuantityRuleOptions: Lookup[];
  public sort: SortDescriptor[] = [
    {
      field: 'Name',
      dir: 'asc',
    },
  ];
  defaultColumnsConfig: ColumnSettings[] = [
    {
      title: 'Item Name',
      field: 'item.name',
      width: 150,
      orderIndex: 0,
      hidden: false
    },
    {
      title: 'Item Number',
      field: 'item.number',
      width: 150,
      orderIndex: 1,
      hidden: true
    },   
    {
      title: 'Amount',
      field: 'Price',
      width: 100,
      orderIndex: 2,
      hidden: false
    },
    {
      title: 'Customer Name',
      field: 'customer.name',
      width: 150,
      orderIndex: 3,
      hidden: false
    },
    {
      title: 'Customer Number',
      field: 'customer.number',
      width: 150,
      orderIndex: 4,
      hidden: true
    },  
    {
      title: 'Pricing Filter',
      field: 'pricingFilter.name',
      width: 150,
      orderIndex: 5,
      hidden: false
    },
    {
      title: 'Location',
      field: 'location.name',
      width: 150,
      orderIndex: 6,
      hidden: true
    },
    {
      title: 'Unit of Measure',
      field: 'uofM.name',
      width: 150,
      orderIndex: 7,
      hidden: true
    },
    {
      title: 'Use Pricing Filter',
      field: 'useFilter',
      width: 150,
      orderIndex: 8,
      hidden: true
    },
    {
      title: 'Quantity Rules',
      field: 'quantityRulesOption.name',
      width: 150,
      orderIndex: 9,
      hidden: true
    }
  ];
  columnsConfig: ColumnSettings[];

  ngOnInit(): void {
    this.loading = true;
    this.columnsConfig = this.defaultColumnsConfig.map(obj => ({ ...obj }));
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.saveGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.priceSheetID && !changes.priceSheetID.firstChange) {
      // We now have an Parent ID so we can change the tooltip.
      document.getElementById('btnAdd').setAttribute('title', 'Add New');
    }
  }

  async onClick_Delete() {
    const modalRef = this.modalService.open(DeleteConfirmationComponent);
    modalRef.componentInstance.confirmDelete.subscribe(() => {
      modalRef.close();
      this.DeleteRecords();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  async DeleteRecords() {
    const ids = [];
    this.mySelection.forEach((value) => {
      ids.push(Number(value));
    });

    await this.priceSheetDetailsService
      .removeByIds(ids)
      .then((showSuccess: VoidFunction) => {
        this.notificationHelper.showStatus('Record(s) deleted successfully!', 'success');
        this.mySelection = [];
      })
      .catch((err: HttpErrorResponse) => {
        this.notificationHelper.showStatus(err.error, "error");
      });

    this.loadListData();
  }

  async onClick_Export(grid: GridComponent, excelComponent: ExcelComponent) {
    this.saveGrid();
    const modalRef = this.modalService.open(ExportConfirmationComponent);
    modalRef.componentInstance.gridRecordCount = this.gridView?.total;
    modalRef.componentInstance.siblingRecordCount = this.globalRecordCount;
    console.log('globalRecordCount is: ', this.globalRecordCount);
    modalRef.componentInstance.hasDescColumns = true;
    modalRef.componentInstance.confirmExport.subscribe((options) => {
      modalRef.close();
      this.loading = true;
      console.log(options.optTechnicalStyle, options.optDescColumns, options.optRowID, options.optSiblingRecords);
      this.exportAll = options.optTechnicalStyle;
      this.optDescColumns = options.optDescColumns;
      this.optRowID = options.optRowID;
      if (options.optTechnicalStyle) {
        if (options.optSiblingRecords) {
          excelComponent.fetchData = this.allGlobalSiblingData;
        }
        else {
          excelComponent.fetchData = this.allData;
        }
      }
      grid.saveAsExcel();
      this.query.PageSize = StorageService.PageSize();
      this.loading = false;
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.loading = false;
    });
  }

  async onClick_ExportOLD(grid: GridComponent, excelComponent: ExcelComponent) {
    this.saveGrid();

    const modalRef = this.modalService.open(ExportConfirmationComponent);
    modalRef.componentInstance.gridRecordCount = this.gridView?.total; 
    modalRef.componentInstance.confirmReImport.subscribe(() => {
      modalRef.close();
      this.loading = true;
      this.exportAll = true;
      excelComponent.fetchData = this.allData;
      grid.saveAsExcel();
      this.query.PageSize = StorageService.PageSize();
      this.loading = false;
    });
    modalRef.componentInstance.confirmExport.subscribe(() => {
      modalRef.close();
      this.loading = true;
      this.exportAll = false;
      grid.saveAsExcel();
      this.query.PageSize = StorageService.PageSize();
      this.loading = false;
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.loading = false;
    });

  }

  onFilterClick() {
    this.filterable = !this.filterable;
  }

  async getPriceSheetDetailQuantityRuleOptions() {
    const PageSize = StorageService.PageSize() ?? 50;
    const Filter_OptionSet = 'QuantityRules';
    const params = { Filter_OptionSet, PageSize };
    this.priceSheetDetailQuantityRuleOptions = await this.lookupService.getList(params);
    const defaultLookup: Lookup = emptyLookup;
    defaultLookup.id = 999;
    defaultLookup.optionSet = "QuantityRules";
    defaultLookup.name = "(All)";
    this.priceSheetDetailQuantityRuleOptions.reverse();
    this.priceSheetDetailQuantityRuleOptions.push(defaultLookup);
    this.priceSheetDetailQuantityRuleOptions.reverse();
    return this.priceSheetDetailQuantityRuleOptions;
  }

  onResetGridClick() {
    StorageService.removeColumnSettings('PriceSheetDetailList_Config');
    this.columnsConfig = this.defaultColumnsConfig.map(obj => ({ ...obj }));
    this.ConfigureGrid();
  }

  ConfigureGrid() {
    // Try and pull our grid configuration from the storage.
    let gridConfig: ColumnSettings[] = StorageService.getColumnSettings('PriceSheetDetailList_Config');

    // If it has not been persisted yet, then persist the default configuration
    if (!gridConfig) {
      StorageService.setColumnSettings('PriceSheetDetailList_Config', this.defaultColumnsConfig);
    } else {
      // Use the updated configuration for the user.
      this.columnsConfig = gridConfig;
    }

    // restore columns to saved configuration
    this.myGrid.columns.forEach((column) => {
      const columnConfig = this.columnsConfig.find(cc => cc.title === column.title);

      if (columnConfig) {
        column.hidden = columnConfig.hidden;
        column.orderIndex = columnConfig.orderIndex;
        column.width = columnConfig.width;
      }
    });
  }

  saveGrid(): void {
    // save column configuration
    this.myGrid.columns.forEach(column => {
      const columnConfig = this.columnsConfig.find(cc => cc.title === column.title);

      if (columnConfig) {
        columnConfig.hidden = column.hidden;
        columnConfig.orderIndex = column.orderIndex;
        columnConfig.width = column.width;
      }
    });

    // sort the array, this is necessary for the excel export
    this.columnsConfig = this.columnsConfig.sort((cc1, cc2) => {
      if (cc1.orderIndex > cc2.orderIndex) {
        return 1;
      }

      if (cc1.orderIndex < cc2.orderIndex) {
        return -1;
      }

      return 0;
    });

    StorageService.setColumnSettings('PriceSheetDetailList_Config', this.columnsConfig);
  }

  ngAfterViewInit() {
    this.loading = true;
    this.ConfigureGrid();    
    this.loading = false;
    this.loadListData();
    this.getPriceSheetDetailQuantityRuleOptions();
  }

  onFilterChange() {
    this.filterChange.emit(this.query);
    this.loadListData();
  }

  onRefresh() {
    this.loadListData();
  }

  async onFileChange(evt: any) {
    await this.importsService.onFileChange(evt, 'RPMPriceSheetDetail');
    this.fileUploader.nativeElement.value = null;
    this.loadListData();
  }

  onFileChangeOLD(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target;

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      //ws.forEach(function(y) {
      //var worksheet = wb.Sheets[y];
      var headers = {};
      var data = [];
      for (const z in ws) {
        if (z[0] === '!') continue;
        //parse out the column, row, and value
        var col = z.substring(0, 1);
        var row = parseInt(z.substring(1));
        var value = ws[z].v;

        //store header names
        if (row == 1) {
          headers[col] = String(value);
          continue;
        }

        if (!data[row]) data[row] = {};
        data[row][headers[col]] = String(value).trim();
      }
      //drop those first two rows which are empty
      data.shift();
      data.shift();
      console.log(data);
      //});
      var myJSONString = JSON.stringify(data);
      var myEscapedJSONString = myJSONString
        .replace(/[\\]/g, '\\\\')
        .replace(/[\']/g, "\\'")
        .replace(/[\"]/g, '\\"')
        .replace(/[\/]/g, '\\/')
        .replace(/[\b]/g, '\\b')
        .replace(/[\f]/g, '\\f')
        .replace(/[\n]/g, '\\n')
        .replace(/[\r]/g, '\\r')
        .replace(/[\t]/g, '\\t');

      const inputXML: string = "'" + myEscapedJSONString + "'";
      this.performImport(inputXML);
    };

    reader.readAsBinaryString(target.files[0]);

    this.fileUploader.nativeElement.value = null;
  }

  async performImport(inputXML) {
    try {
      const response: any = await this.importsService.performImport(inputXML, 'RPMPriceSheetDetail');
      const status: any = response.status;
      if (status === 200) {
        this.snack.openSnackBar(
          'Completed Import successfully!' + response.body,
          '',
          false,
          'Success',
          'alert-success',
        );
        this.loadListData();
      }
    } catch (e) {
      this.snack.openSnackBar(e.error, '', true, 'Error', 'alert-danger');
    }
  }

  onCellClick(e) {
    this.clickedRowItem = e.dataItem;
  }

  onDblClick() {
    if (this.clickedRowItem) {
      this.onEdit(this.clickedRowItem);
    }
  }

  public gridFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.query = { PageNumber: 1, PageSize: this.query.PageSize, SortTerm: 'name', SearchTerm: '' };
    if (filter.filters.length > 0) {
      filter.filters.forEach((value) => {
        const myFilter: FilterDescriptor = value as FilterDescriptor;
        if (myFilter.field == 'item.name') {
          const Filter_Item = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_Item = myFilter.operator;
          const params = { ...this.query, Filter_Item, Operand_Item };
          this.query = params;
        }
        if (myFilter.field == 'item.number') {
          const Filter_ItemNumber = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_ItemNumber = myFilter.operator;
          const params = { ...this.query, Filter_ItemNumber, Operand_ItemNumber };
          this.query = params;
        }
        if (myFilter.field == 'uofM.name') {
          const Filter_UnitOfMeasure = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_UnitOfMeasure = myFilter.operator;
          const params = { ...this.query, Filter_UnitOfMeasure, Operand_UnitOfMeasure };
          this.query = params;
        }
        if (myFilter.field == 'location.name') {
          const Filter_Location = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_Location = myFilter.operator;
          const params = { ...this.query, Filter_Location, Operand_Location };
          this.query = params;
        }
        if (myFilter.field == 'customer.name') {
          const Filter_Customer = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_Customer = myFilter.operator;
          const params = { ...this.query, Filter_Customer, Operand_Customer };
          this.query = params;
        }
        if (myFilter.field == 'customer.number') {
          const Filter_CustomerNumber = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_CustomerNumber = myFilter.operator;
          const params = { ...this.query, Filter_CustomerNumber, Operand_CustomerNumber };
          this.query = params;
        }
        if (myFilter.field == 'useFilter') {
          const Filter_UseFilter = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_UseFilter = myFilter.operator;
          const params = { ...this.query, Filter_UseFilter };
          this.query = params;
        }
        if (myFilter.field == 'pricingFilter.name') {
          const Filter_PricingFilter = (myFilter.value == null) ? "" : myFilter.value;
          const Operand_PricingFilter = myFilter.operator;
          const params = { ...this.query, Filter_PricingFilter, Operand_PricingFilter };
          this.query = params;
        }
        if (myFilter.field == 'price') {
          const Filter_Price = myFilter.value;
          const Operand_Price = myFilter.operator;
          const params = { ...this.query, Filter_Price, Operand_Price };
          this.query = params;
        }
        if (myFilter.field == 'quantityRulesOption.name') {
          if (myFilter.value != '(All)') {
            const Filter_QuantityRules = (myFilter.value == null) ? "" : myFilter.value;
            const Operand_QuantityRules = myFilter.operator;
            const params = { ...this.query, Filter_QuantityRules, Operand_QuantityRules };
            this.query = params;
          }
        }

      });
    }
    this.onFilterChange();
  }
  edit(id: number) {
    this.router.navigate([`/price/price-sheet-detail/${id}`]);
  }

  public allData = (): Promise<any> => {
    this.query.PageSize = 200000;
    this.query.PageNumber = 1;
    this.loading = true;
    return this.priceSheetDetailsService.getExportList({
      Filter_PriceSheetID: this.priceSheetID, ...this.query
    });
  }

  public allGlobalSiblingData = (): Promise<any> => {
    this.query.PageSize = 200000;
    this.query.PageNumber = 1;
    this.loading = true;
    return this.priceSheetDetailsService.getExportList({
       ...this.query
    });
  }

  async getGlobalSiblingDataCount() {
    this.loading = true;
    try {
      const response: any = await this.priceSheetDetailsService.getList({ PageSize: 1, PageNumber: 1 });
      this.loading = false;
      const pagination  = getPaginationHeader(response.headers);
      this.globalRecordCount = pagination.TotalCount;
    } catch (error) {
      this.loading = false;
      console.error("Error fetching total count: ", error);
    }
  }

  async remove(modal) {
    const ids = [];
    this.mySelection.forEach((value) => {
      ids.push(Number(value));
    });
    await this.priceSheetDetailsService
      .removeByIds(ids)
      .then((showSuccess: VoidFunction) => {
        this.snack.openSnackBar(
          'Record(s) deleted successfully!',
          '',
          false,
          'Success',
          'alert-success',
        );
        this.mySelection = [];
      })
      .catch((err: HttpErrorResponse) => {
        this.snack.openSnackBar(
          err.error,
          '',
          true,
          'Error',
          'alert-danger',
        );
      });

    modal.close();
    this.loadListData();
  }

  get disableDeleteBtn() {
    return !Object.keys(this.mySelection).length;
  }

  get disableEditBtn() {
    return Object.keys(this.mySelection).length !== 1;
  }

  onSelectSingleItem(item) {
    this.onSelectSingle.emit(item);
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.query.PageNumber = event.skip / event.take + 1;
    this.loadListData();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    if (sort[0].dir == 'asc') {
      this.query.SortTerm = sort[0].field;
    } else if (sort[0].dir == 'desc') {
      this.query.SortTerm = '-' + sort[0].field;
    } else {
      this.query.SortTerm = sort[0].field;
    }
    this.loadListData();
  }

  async loadListData() {
    this.loading = true;
    this.query.PageSize = StorageService.PageSize() ?? 50;
    try {
      if (this.priceSheetID) {
        document.getElementById('btnAdd').setAttribute('title', 'Add New');
        const response: any = await this.priceSheetDetailsService.getList({
          Filter_PriceSheetID: this.priceSheetID, ...this.query
        });
        this.priceSheetDetails = response.body;
        this.pagination = getPaginationHeader(response.headers);
        this.gridView = {
          data: this.priceSheetDetails,
          total: this.pagination.TotalCount,
        };
      }
    } catch (e) {
    } finally {
      this.loading = false;
    }
    this.getGlobalSiblingDataCount();
  }

  onCreate() {
    const modalRef = this.modalService.open(
      PriceSheetDetailSingleComponent,
      {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: "PriceSheetDetailModalClass",
        centered: true,
        backdrop: 'static',
      },
    );
    modalRef.componentInstance.idOfPriceSheet = this.priceSheetID;
    modalRef.componentInstance.onFormSaved.subscribe(() => {
      this.loadListData();
      //modalRef.close();
    });
  }

  onEdit(priceSheetDetail) {
    const modalRef = this.modalService.open(
      PriceSheetDetailSingleComponent,
      {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: "PriceSheetDetailModalClass",
        centered: true,
        backdrop: 'static',
      },
    );
    modalRef.componentInstance.idOfPriceSheetDetail = priceSheetDetail.id;
    modalRef.componentInstance.onFormSaved.subscribe(() => {
      this.loadListData();
      //modalRef.close();
    });
  }
}
